export default __webpack_public_path__ + "static/media/agustin16.52631819.png";